import { Link } from "react-router-dom";
import { Facebook, Instagram, Mail, MapPin, Phone } from "lucide-react";
import { SITE } from "@/constants/site";

function TikTokIcon(props) {
  return (
    <svg viewBox="0 0 24 24" fill="currentColor" width="20" height="20" {...props}>
      <path d="M21 8.5a7.5 7.5 0 0 1-4.6-1.6v8.6A6.5 6.5 0 1 1 9.9 9V12a3.5 3.5 0 1 0 2.5 3.3V2h3a4.5 4.5 0 0 0 4.5 4.5v2z" />
    </svg>
  );
}

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="bg-[#0B1B3A] text-white mt-24">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-10">
          <div className="md:col-span-2">
            <div className="flex items-center gap-3 mb-4">
              <img src="/logo.jpg" alt="Advanced Coaching" className="w-14 h-14 rounded-full object-cover ring-2 ring-[#F59E0B]/60" />
              <div>
                <div className="font-display font-bold uppercase text-xl">Advanced <span className="text-[#FBBF24]">Coaching</span></div>
                <div className="text-[10px] uppercase tracking-[0.25em] text-slate-400">Est. 2025</div>
              </div>
            </div>
            <p className="text-slate-300 max-w-md text-sm leading-relaxed">
              1-to-1, small group and schools coaching led by FA qualified, DBS-checked coaches.
            </p>
            <div className="flex items-center gap-3 mt-6">
              <a data-testid="social-facebook" aria-label="Facebook" href={SITE.socials.facebook} target="_blank" rel="noreferrer" className="w-10 h-10 grid place-items-center rounded-full border border-white/15 hover:bg-[#2563EB] hover:border-[#2563EB] transition">
                <Facebook className="w-4 h-4" />
              </a>
              <a data-testid="social-instagram" aria-label="Instagram" href={SITE.socials.instagram} target="_blank" rel="noreferrer" className="w-10 h-10 grid place-items-center rounded-full border border-white/15 hover:bg-[#F59E0B] hover:text-[#0B1B3A] hover:border-[#F59E0B] transition">
                <Instagram className="w-4 h-4" />
              </a>
              <a data-testid="social-tiktok" aria-label="TikTok" href={SITE.socials.tiktok} target="_blank" rel="noreferrer" className="w-10 h-10 grid place-items-center rounded-full border border-white/15 hover:bg-white hover:text-[#0B1B3A] hover:border-white transition">
                <TikTokIcon />
              </a>
            </div>
          </div>

          <div>
            <h4 className="eyebrow text-[#FBBF24] mb-4">Explore</h4>
            <ul className="space-y-2 text-sm text-slate-300">
              <li><Link to="/" className="hover:text-white">Home</Link></li>
              <li><Link to="/about" className="hover:text-white">About Us</Link></li>
              <li><Link to="/private-sessions" className="hover:text-white">Private Sessions</Link></li>
              <li><Link to="/faqs" className="hover:text-white">FAQs</Link></li>
              <li><Link to="/contact" className="hover:text-white">Contact</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="eyebrow text-[#FBBF24] mb-4">Get in touch</h4>
            <ul className="space-y-3 text-sm text-slate-300">
              <li className="flex items-start gap-2"><Mail className="w-4 h-4 mt-0.5 text-[#FBBF24]" /> <a href={`mailto:${SITE.email}`} className="hover:text-white">{SITE.email}</a></li>
              <li className="flex items-start gap-2"><Phone className="w-4 h-4 mt-0.5 text-[#FBBF24]" /> <a href={`tel:${SITE.phone}`} className="hover:text-white">{SITE.phone}</a></li>
              <li className="flex items-start gap-2"><MapPin className="w-4 h-4 mt-0.5 text-[#FBBF24]" /> {SITE.address}</li>
            </ul>
          </div>
        </div>

        <div className="mt-12 pt-6 border-t border-white/10 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-2 text-xs text-slate-400">
          <div>© {new Date().getFullYear()} Advanced Coaching. All rights reserved.</div>
          <div className="flex gap-4">
            <span>FA Qualified · DBS Checked · Safeguarding Trained</span>
          </div>
        </div>
      </div>
    </footer>
  );
}
